import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { RootState } from "../../app/store";
import { OrderStatus } from "../../models/responses/orderStatus";
import { ClientType } from "../../models/enums/clientTypeEnum";
import { Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { getOrderStatuses } from "../../app/services/orderStatusService";

interface Props { }

const OrderStatusIndex: FC<Props> = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { instance, accounts } = useMsal();
    const orderStatusList = useSelector(
        (state: RootState) => state.orderStatus.setOrderStatusList
    ) as OrderStatus[];
  const loadingOrderStatuses = useSelector(
    (state: RootState) => state.orderStatus.isWaitingOrderStatusListGetResponse
  );
    useEffect(() => {
        if (accounts[0]) {
            dispatch(getOrderStatuses(instance, accounts[0], null) as any);
        }
    }, [dispatch, instance, accounts]);

    const openOrderStatusHandler = (status: OrderStatus) => {
        navigate(`/admin/order-status/view/${status.id}`, { relative: "path" });
        
    };

    const clientTypeLabel = (types: ClientType[] | null) => {
        if (!types || types.length === 0) return "Alla";
        const labels = types.map(type => {
            switch (type) {
                case ClientType.Standard:
                    return "Standard";
                case ClientType.Catalog:
                    return "Katalog";
                case ClientType.Fleet:
                    return "Fleet";
                default:
                    return "";
            }
        });
        return labels.join(", ");
    };

    return (
        <div>
            <Row className="mb-3">
                <Col>
                    <h1>Orderstatusar</h1>
                </Col>
                <Col className="text-end">
                    <Button
                        className="mt-2 ms-2"
                        variant="outline-primary"
                        href={`/admin/order-status/add`}
                    >
                        Lägg till <Plus />
                    </Button>
                </Col>
            </Row>

            <Table responsive striped bordered hover>
                <thead>
                    <tr>
                        <th>Namn</th>
                        <th>Sortering</th>
                        <th>Klient-typ</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {orderStatusList.map((status) => (
                        <tr
                            key={status.id}
                            role="button"
                            onClick={() => openOrderStatusHandler(status)}
                        >
                            <td>{status.name}</td>
                            <td>{status.sortOrder}</td>
                            <td>{clientTypeLabel(status.clientTypes)}</td>
                            <td align="center">
                                <Eye />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {loadingOrderStatuses && (
                <>
                    <Row className="mb-3">
                        <Col className="text-center">
                            <Spinner variant="primary" />
                        </Col>
                    </Row>
                </>
            )}

        </div>
    );
};

export default OrderStatusIndex;